import CanvasDrawerMessage from './CanvasDrawerMessage';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';
import snakeCase from 'lodash/snakeCase';
import get from 'lodash/get';
import { withModel } from '../../../data-providers/model';
import { replaceTextWithValues } from 'src/common/utils/text-replace';

const alertedDrawersOnNameUpdate = ['adventurer', 'multi-adventurer'];

const buildRichTextFields = text => text && [{
  type: 'paragraph',
  text,
  spans: []
}];

const getMessage = props => {
  if (props.message) {
    if (typeof props.message === 'string') {
      props.updateVisibility(true);
      return buildRichTextFields(props.message);
    }
  }
  if (!props.drawer) {
    return null;
  }
  const [ drawerId, drawerType ] = props.drawer.split('::');
  const canvasGlobalContent = props.model.prismicGlobalContentModel.canvas;
  const canvasDrawerSlice = canvasGlobalContent.body.find(item => item.sliceType === 'canvas_drawer_messages');
  const canvasDrawerMessages = get(canvasDrawerSlice, 'items', []);
  const drawerAlerts = canvasDrawerMessages.filter(item => snakeCase(item.canvasDrawerId) === drawerId) || [];
  const drawerAlert = drawerAlerts.find(item => !item.when) || {};
  const drawerAlertWhenNameIsUpdated = drawerAlerts.find(item => item.when === 'name-is-updated');
  const canvasDrawerSteps = canvasGlobalContent.stepCounter;
  const stepCounterMessage = get(canvasDrawerSteps, [props.stepsLeft, 'message'], '');

  const drawerContent = props.drawers.find(item => {
    if (drawerId === 'interest') {
      return item.primary.type === drawerType;
    }
    return item.sliceType === drawerId;
  });

  const isInscriptionCompleted = props.completedDrawersMap.complete.some(item => item.includes('inscription'));
  const nameIsUpdated = alertedDrawersOnNameUpdate.includes(drawerAlert.canvasDrawerId) && isInscriptionCompleted;
  let message = drawerContent.primary.tabCompleteMessageOverride || drawerAlert.messageString;
  
  if (nameIsUpdated && drawerAlertWhenNameIsUpdated) {
    message = drawerAlertWhenNameIsUpdated.messageString;
  }

  props.updateVisibility(true);
  return buildRichTextFields(replaceTextWithValues(message, { step_counter: stepCounterMessage }));
};

const enhance = compose(
  withModel,
  withState('visible', 'updateVisibility', false),
  withState('message', 'updateMessage', getMessage),
  lifecycle({
    componentDidUpdate(prevProps) {
      const props = this.props;
      if (props.drawer && props.drawer !== prevProps.drawer) {
        prevProps.updateMessage(getMessage(props));
      }
      if (!props.drawer && props.drawer !== prevProps.drawer) {
        prevProps.updateVisibility(false);
      }
    }
  })
);

export default enhance(CanvasDrawerMessage);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CanvasDrawers/CanvasDrawerMessage/index.js